import {
    allShopTemplates,
    defaultShopTemplate,
    getShopTemplate,
} from "./shopRegistry";
import type { SiteTemplateDefinition } from "./types";
import {
    allWebTemplates,
    defaultWebTemplate,
    findWebTemplate,
    getWebTemplate,
    webTemplates,
} from "./webRegistry";

export const allSiteTemplates: SiteTemplateDefinition[] = [
    ...allWebTemplates,
    ...allShopTemplates,
];

export const siteTemplates = webTemplates;

export const defaultSiteTemplate = defaultWebTemplate;
export { defaultShopTemplate };

export function findSiteTemplate(code?: string | null): SiteTemplateDefinition | undefined {
    return findWebTemplate(code);
}

export function getSiteTemplate(code?: string | null): SiteTemplateDefinition {
    return getWebTemplate(code);
}

export function getShopSiteTemplate(code?: string | null): SiteTemplateDefinition {
    return getShopTemplate(code);
}
